import { combineReducers } from 'redux';
import user from './user/user.js';
import nav from './nav/nav.js';
import workstation from './workstation/workstation.js';
import workstationState from './workstationState/workstationState.js';
import qualityCheck from './qualityChecks/qualityCheck.js';
import general from './general/general.js';
import machineParameter from './machineParameter/machineParameter.js';
import notification from './notification/notification.js';
import dashboard from './dashboard/dashboard.js';
import planning from './planning/planning.js';

const rootReducer = combineReducers({
  user,
  nav,
  workstation,
  qualityCheck,
  general,
  machineParameter,
  notification,
  workstationState,
  dashboard,
  planning
});

// const rootReducer = (initialState, state,action) => {
  
//     state = initialState;
// }

export default rootReducer;